<template>
  <RevContainer v-if="width === 'fixed'" class="[&>*]:min-w-0">
    <div class="md:min-w-full md:max-w-[752px] lg:max-w-[1184px]">
      <slot />
    </div>
  </RevContainer>

  <div v-else-if="width === 'full-width'">
    <slot />
  </div>

  <div
    v-else-if="width === 'adaptive'"
    class="m-auto md:px-24 lg:max-w-[1120px] lg:px-0"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { RevContainer } from '@ds/components/Container'

withDefaults(defineProps<{ width?: 'adaptive' | 'full-width' | 'fixed' }>(), {
  width: 'fixed',
})
</script>
